import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { PlansSection } from "@/components/PlansSection";

const Plans = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Planos e Assinaturas | Justiçai";
  }, []);

  return (
    <div className="min-h-screen bg-gray-900">
      <div className="container max-w-6xl mx-auto py-8 px-4">
        <div className="flex items-center mb-8">
          <Button
            variant="ghost"
            onClick={() => navigate('/configuracoes')}
            className="mr-4 text-white hover:bg-gray-800 hover:text-white"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Voltar às configurações
          </Button>
          <h1 className="text-3xl font-bold text-white">Planos e Assinaturas</h1>
        </div>

        <PlansSection />
      </div>
    </div>
  );
};

export default Plans;
